import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  avatar: {
    // O fundo agora usa o cinza-aço altamente visível (#4F535D) e é imune a conflitos!
    backgroundColor: theme.palette.type === 'dark' 
      ? '#4F535D' 
      : '#e8eaf6',
    color: theme.palette.type === 'dark' 
      ? '#FFFFFF' 
      : '#1a237e',
    width: '40px', // Robustez estética e maior contorno visível!
    height: '40px',
    border: 'none',
    boxShadow: 'none',
    transition: 'all 0.3s ease',
    '& svg': {
      fontSize: '1.5rem', // Ícone robusto e equilibrado
      color: theme.palette.type === 'dark' 
        ? '#FFFFFF' 
        : '#1a237e',
    }
  },
}))

export default useStyles
